import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { CustomNextImage as Image, TAppProps } from '@crehana/next';
import { getQueryParam } from '@crehana/utils';
import { Signup as SignupForm } from '@crehana/web';

import { AuthSEO, CustomNavbar } from '@/shared/components';

import Title from './components/Title';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { IAppProps } from './types';

const App: React.FC<React.PropsWithChildren<TAppProps<IAppProps>>> = ({
  featureFlags: { hideFacebookButton, hideFacebookLink },
  query,
}) => {
  const { t } = useTranslation();

  /*
    We are getting the query params on the client side because the server side
    is using cache and doesn't let to handle dynamic real time query params
  */
  const hasCampaignSlug =
    typeof getQueryParam('campaign_slug') === 'string' &&
    getQueryParam('campaign_slug') === 'hp';

  console.log({ query });

  return (
    <>
      <AuthSEO
        title={t('SEO_TITLE', {
          defaultValue: 'Regístrate',
        })}
        description={t('SEO_DESCRIPTION')}
      />

      <div
        className="relative w-full h-full bg-base-main"
        css={`
          ${
            hasCampaignSlug
              ? `
              background: radial-gradient(
                85.92% 87.45% at 10.07% 20.91%,
                rgba(30, 44, 95, 0.5) 0%,
                rgba(50, 138, 138, 0) 90.33%
                ),
                radial-gradient(
                  33.05% 45.75% at 85.87% 38.4%,
                  rgba(97, 24, 154, 0.25) 0%,
                  rgba(13, 29, 85, 0) 100%
                ),
                radial-gradient(
                  143.98% 62.02% at 50% 0%,
                  #3417aa 0%,
                  rgba(7, 14, 39, 0) 100%
                ),
                radial-gradient(
                  119.86% 119.86% at 50% -19.86%,
                  rgba(7, 14, 39, 0) 48.43%,
                  #070e27 100%
                ),
                #070e27;
              backdrop-filter: blur(20px);
            `
              : ''
          };
        `}
      >
        <main
          className={`flex items-start w-full min-h-screen h-full p-16 ${
            hasCampaignSlug
              ? 'flex-col justify-start'
              : 'flex-wrap justify-center'
          }`}
        >
          <CustomNavbar isBgTransparent={hasCampaignSlug} />
          <div data-testid="signup-container" className="relative mx-auto">
            <div className="mb-32 text-center">
              {hasCampaignSlug && (
                <Image
                  src={
                    'https://crehana-public-catalog.imgix.net/images/app/gallery/2022/02/24/22f65060/5c34013d.png'
                  }
                  alt="hp"
                  height={80}
                  width={80}
                  className="block mb-8"
                />
              )}
              <Title isCampaignTitle={hasCampaignSlug}></Title>
            </div>
            <div
              style={{
                maxWidth: 320,
                margin: 'auto',
              }}
            >
              <SignupForm
                hideFacebookButton={hideFacebookButton}
                hideFacebookLink={hideFacebookLink}
                isDark
                canShowPhoneInput={!hasCampaignSlug}
                shouldHideTitle
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default App;
